import type { FaireProductEntity } from "../../entity_types/product";

export const p_2sd6y7tgsw: FaireProductEntity = {
  token: "p_2sd6y7tgsw",
  type: "product",
  name: "SHORT SLEEVE ROUND NECK OVERSIZED STRIPE T-SHIRT",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/2b45987d6caa2d523a398b7c89b248cc384a8b77ea9c38f1c2ba66cd0fc863fb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e415a1ed74816720355e8ae83f1c3f17477849b091d3f78b06d1e99d33e92738.jpeg",
    "https://cdn.faire.com/fastly/5032dfcbb0259d8a831aa1bbd1cea144d28c682a7d649f48bdbea508d0d381be.jpeg",
    "https://cdn.faire.com/fastly/d46a0ffbbdd970bd31069466dac56b5992e0162b6beb28de7c92415f9f7ebcd0.jpeg",
    "https://cdn.faire.com/fastly/f0dfed4e786a469e4a64d44912e45d0fafd77f4d81211b4dd2ce862fba32bbb2.jpeg",
    "https://cdn.faire.com/fastly/08e493c73d48b336aa4c8f06bd43b2b3940824824cc136f7c6c8983b7583baaf.jpeg",
    "https://cdn.faire.com/fastly/e00472af3fd9cea3defc3ae463f67b92b16be3aca9920fbd64b08ba2d7093f4a.jpeg",
    "https://cdn.faire.com/fastly/0734bf24ced0e7e1da8c9f710627974546a5e78bb049e912c56fb93efb46b8da.jpeg",
    "https://cdn.faire.com/fastly/7679a14177d6db8c6f3260a3938705c25926bd9b04beaef13b5f3881a0bc3233.jpeg",
    "https://cdn.faire.com/fastly/c84cdec2459d03a2f2231731f5d0c2028830cd04b058d47fe2fe90ed0004420a.jpeg",
    "https://cdn.faire.com/fastly/ac4d07d81dab8ed54dcf987a1107eef8d156f762e62d35cdbc8ea3e5528c6721.jpeg",
    "https://cdn.faire.com/fastly/91b9731bac04b20030e3eb819188ed4c16acedae1a784702b5fc5d111edcf971.jpeg",
    "https://cdn.faire.com/fastly/4d5df83fa16eea1aeec48e809d60c8d963c784598beb6ef297ceb1d816e2f026.jpeg",
    "https://cdn.faire.com/fastly/ab3b0582f2fdb729225b55f6b4730238bd436b0b42bea4548eca724a0910bac1.jpeg",
    "https://cdn.faire.com/fastly/e84d44c1f2dd97dfcc3dc0a6d9ea1b0908526a077cafd95a61d4a67ccd10647d.jpeg",
    "https://cdn.faire.com/fastly/d55b9c570ac1d973cf7d748719a8f286f47b83462f09a20413e442ea5311beee.jpeg",
    "https://cdn.faire.com/fastly/db416e0e3942fe956c47bbdcdd4398b9e62d2b925b38831613428cb5f81a3162.jpeg",
    "https://cdn.faire.com/fastly/94ed52ac2c3fcacc3ebfa6e5a7b9809c5eadde807cb322318b7eff1ee2f50826.jpeg",
    "https://cdn.faire.com/fastly/14bc65488cc42e6c8dc66d59784f90ca1c46a9173ea5d641535a597c1caf5bd3.jpeg",
    "https://cdn.faire.com/fastly/87791a619aa629c0009ffbbb3ccb864a87d8d555facdeb74d3523f028bcec513.jpeg",
    "https://cdn.faire.com/fastly/2ff819dcf7ee7cde9434ab71956c19ea2fb18c891b4a752606efe741336d7611.jpeg",
    "https://cdn.faire.com/fastly/5d90c1947943e39de14f941582b3a48fcfd8bc0ef1a0634b0b2f9f0d8154182f.jpeg",
    "https://cdn.faire.com/fastly/e4a4b42335d3d4d646251618e5a89563f20d566603119b2cbb0eb1246fea777b.jpeg",
    "https://cdn.faire.com/fastly/57608780cde36cef6941f331a125ab1465f386681b8ded8aa865e18b732b62c7.jpeg",
    "https://cdn.faire.com/fastly/8b5c4720ae2cb461f2c935c3e8d44d7eb9c9d2a82874acd0cfc1860507d20b59.jpeg",
    "https://cdn.faire.com/fastly/706184a7aab14a7b5de8db8c7cefd437d5fd7bcd0fc5c257ff4a33586361af15.jpeg",
    "https://cdn.faire.com/fastly/363d53b80a881b355e6403891a4a718bd29a1b34f487461fac65ae301dce1007.jpeg",
    "https://cdn.faire.com/fastly/6dce0a6912cd759492c3a197f139246d46f0fbecae45b5764f9a007bff1fb7d3.jpeg",
    "https://cdn.faire.com/fastly/d2246a6b171e7e99c0138dfeca9b879c118344870afe2ea6f6e69884acda301a.jpeg",
    "https://cdn.faire.com/fastly/5b3ca5a963f6ef68347d5b97465f5cd0e842e175dec950e3711b3611dbcc04fc.jpeg",
    "https://cdn.faire.com/fastly/fd340622a5633c2bdff9d777832fef5064c5069b471a8aa0e1ca247bfc7bee8b.jpeg",
    "https://cdn.faire.com/fastly/74025fc5c36a4d681577f5240b0b0ce67734e68e60ae031b473ca1d400cf1d90.jpeg",
    "https://cdn.faire.com/fastly/d5cebd81281aac1856525c465eeadd7529610cfcc8317e88ebecee1414191779.jpeg",
    "https://cdn.faire.com/fastly/72b37ebb9a1b02f2562fd0877287034d32f2236392d448410884502d1c448372.jpeg",
    "https://cdn.faire.com/fastly/ff9662e12a09326d65b7ac6f2080484dc228c0da62fa0e5426d44ef0fdf2b9ca.jpeg",
    "https://cdn.faire.com/fastly/a33d71e038c2eda2fb90756cf86d81372c3601c11100cc764a9859461edca039.jpeg",
    "https://cdn.faire.com/fastly/013f78472769b174e3ea16b64219d4db378f13567f886904d23c9e88934950d2.jpeg",
    "https://cdn.faire.com/fastly/6e74a4daf38a6673e9df39300989b3a8e9242f97931141a27145359d4412db86.jpeg",
    "https://cdn.faire.com/fastly/c36c84e2fdde479f7b8d99fa71976af732c30db7cade9f0664306a20555b9ce4.jpeg",
    "https://cdn.faire.com/fastly/1d496d03860d0b5dc3679d7d9933fc35f7a8c59ca79ecbde25b51f57fe2ce51b.jpeg",
    "https://cdn.faire.com/fastly/589acbb2579c3696967c91490728d67984e53e7927ad11a3ce0a331b0c95e6c0.jpeg",
    "https://cdn.faire.com/fastly/d0fe67948a0965b124383a4677f4373f9ed2be51dcb4dcad569ab79f1084369c.jpeg",
    "https://cdn.faire.com/fastly/3b3c0aa5d277b978b6263b28257973a63e14728431f420813d2031bd55b18ac7.jpeg",
    "https://cdn.faire.com/fastly/a3e76690ba97ec4d6cdd0738f5cd94256798a5d7ecd43f2460e7929d83d5625c.jpeg",
  ],
  priceDollars: 114,
  description:
    'Top Only\n\n(Matching set with: IS6335)\n\nModel is wearing a size small\n\nModel Specs\n• Height: 5\'8"\n• Bust: 32B\n• Waist: 24"\n• Hips: 34"',
  tags: [],
  msrpDollars: 228,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:06.078Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
